(function () {
    'use strict';

    function escapeHtml(str) {
        if (str === null || typeof str === 'undefined') return '';
        const div = document.createElement('div');
        div.textContent = String(str);
        return div.innerHTML;
    }

    function getMoneyFormat() {
        return document.body && document.body.getAttribute('data-money-format')
            ? document.body.getAttribute('data-money-format')
            : ((window.Shopify && Shopify.money_format) || '${{amount}}');
    }

    function isFormattedMoneyString(value) {
        return typeof value === 'string' && /[$£€¥₱₹₩₪₴₫]|&#|&[a-z]+;|[A-Z]{2,}/i.test(value);
    }

    function moneyValueToCents(value) {
        if (value === null || typeof value === 'undefined' || value === '') return '';

        if (typeof value === 'number') {
            return Number.isFinite(value) ? Math.round(value) : '';
        }

        const stringValue = String(value).trim();
        if (!stringValue || isFormattedMoneyString(stringValue)) return '';

        const cleaned = stringValue.replace(/,/g, '');
        const numeric = Number(cleaned);
        if (Number.isNaN(numeric)) return '';

        return cleaned.indexOf('.') > -1 ? Math.round(numeric * 100) : Math.round(numeric);
    }

    function formatMoneyValue(value) {
        if (value === null || typeof value === 'undefined' || value === '') return '';

        if (isFormattedMoneyString(value)) {
            return value;
        }

        const cents = moneyValueToCents(value);
        if (cents === '') {
            return escapeHtml(value);
        }

        if (window.Shopify && typeof Shopify.formatMoney === 'function') {
            return Shopify.formatMoney(cents, getMoneyFormat());
        }

        return '$' + (cents / 100).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    function getOptionNames(product) {
        if (product && Array.isArray(product.options_with_values) && product.options_with_values.length) {
            return product.options_with_values.map(function (option) {
                return option && option.name ? option.name : '';
            });
        }

        if (product && Array.isArray(product.options) && product.options.length) {
            return product.options.map(function (option) {
                if (typeof option === 'string') return option;
                return option && option.name ? option.name : '';
            });
        }

        return [];
    }

    function getVariantOptions(variant) {
        if (!variant) return [];

        if (Array.isArray(variant.options) && variant.options.length) {
            return variant.options.slice();
        }

        const options = [];
        if (typeof variant.option1 !== 'undefined' && variant.option1 !== null) options.push(variant.option1);
        if (typeof variant.option2 !== 'undefined' && variant.option2 !== null) options.push(variant.option2);
        if (typeof variant.option3 !== 'undefined' && variant.option3 !== null) options.push(variant.option3);
        return options;
    }

    function normalizeVariants(product) {
        if (!product || !Array.isArray(product.variants)) return [];

        return product.variants.map(function (variant) {
            return {
                id: variant.id,
                available: typeof variant.available === 'boolean' ? variant.available : true,
                price: typeof variant.price !== 'undefined' ? variant.price : product.price,
                compare_at_price: typeof variant.compare_at_price !== 'undefined' ? variant.compare_at_price : product.compare_at_price,
                options: getVariantOptions(variant)
            };
        });
    }

    function getSelectedVariant(product, variants) {
        const selectedId = product && (product.selected_variant_id || product.selectedVariantId);
        const selectedById = selectedId
            ? variants.find(function (variant) { return String(variant.id) === String(selectedId); })
            : null;

        return selectedById
            || variants.find(function (variant) { return variant.available; })
            || variants[0]
            || null;
    }

    function getOptionValues(product, optionIndex, variants) {
        if (product && Array.isArray(product.options_with_values) && product.options_with_values[optionIndex]) {
            const option = product.options_with_values[optionIndex];
            if (Array.isArray(option.values) && option.values.length) {
                return option.values.slice();
            }
        }

        if (product && Array.isArray(product.options) && product.options[optionIndex]) {
            const option = product.options[optionIndex];
            if (option && Array.isArray(option.values) && option.values.length) {
                return option.values.slice();
            }
        }

        const seen = [];
        variants.forEach(function (variant) {
            const value = variant && Array.isArray(variant.options) ? variant.options[optionIndex] : '';
            if (value && seen.indexOf(value) === -1) {
                seen.push(value);
            }
        });
        return seen;
    }

    function hasOnlyDefaultVariant(product, optionNames, variants) {
        if (product && (product.has_only_default_variant === true || product.hasOnlyDefaultVariant === true)) {
            return true;
        }

        if (!optionNames.length) {
            return true;
        }

        if (optionNames.length !== 1 || !/title/i.test(optionNames[0])) {
            return false;
        }

        const values = getOptionValues(product, 0, variants);
        return values.length <= 1 && values.every(function (value) {
            return /default title/i.test(String(value || ''));
        });
    }

    function getQuickaddOptionIndex(optionNames) {
        let found = -1;

        optionNames.forEach(function (name, index) {
            if (found !== -1) return;
            if (/size/i.test(name || '')) found = index;
        });

        optionNames.forEach(function (name, index) {
            if (found !== -1) return;
            if (/colou?r/i.test(name || '')) found = index;
        });

        optionNames.forEach(function (name, index) {
            if (found !== -1) return;
            if (/style/i.test(name || '')) found = index;
        });

        if (found === -1 && optionNames.length) {
            found = 0;
        }

        return found;
    }

    function getImageUrl(image) {
        if (!image) return '';
        if (typeof image === 'string') return image;
        return image.url || image.src || image.image || '';
    }

    function sizedShopifyImageUrl(url, width) {
        if (!url || !width) return url || '';

        const normalized = String(url);
        if (!/(cdn\.shopify\.com|\/cdn\/shop\/)/.test(normalized)) return normalized;
        if (/[?&]width=\d+/.test(normalized)) {
            return normalized.replace(/([?&]width=)\d+/, '$1' + width);
        }

        return normalized + (normalized.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    }

    function buildImageSrcset(url, widths) {
        if (!url) return '';

        return (widths || [160, 220, 280, 360, 440, 560, 640, 800]).map(function (width) {
            return sizedShopifyImageUrl(url, width) + ' ' + width + 'w';
        }).join(', ');
    }

    function getPrimaryImage(product) {
        return getImageUrl(
            (product && (product.featured_image || product.featured_media))
            || (product && Array.isArray(product.images) ? product.images[0] : '')
            || product.image
        );
    }

    function getSecondaryImage(product) {
        if (!product || !Array.isArray(product.images) || product.images.length < 2) return '';
        return getImageUrl(product.images[1]);
    }

    function renderActionButtons(product, options, url, title, image, priceHtml, showQuickView) {
        const id = product && product.id ? product.id : '';
        const handle = product && product.handle ? product.handle : '';

        const wishlistButton = options.showWishlist === false ? '' : `
            <button
              class="wcwy-card__action-btn wcwy-card__wishlist"
              data-wishlist-btn
              data-product-id="${escapeHtml(id)}"
              data-product-handle="${escapeHtml(handle)}"
              data-product-title="${escapeHtml(title)}"
              data-product-image="${escapeHtml(image)}"
              data-product-price="${escapeHtml(priceHtml)}"
              data-product-url="${escapeHtml(url)}"
              aria-label="Add to wishlist"
              aria-pressed="false"
              type="button"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
              </svg>
            </button>`;

        const quickViewButton = showQuickView ? `
            <button
              class="wcwy-card__action-btn wcwy-card__quickview"
              type="button"
              aria-label="Quick view ${escapeHtml(title)}"
              aria-busy="false"
              aria-haspopup="dialog"
              data-quickview-btn
              data-product-handle="${escapeHtml(handle)}"
              data-product-title="${escapeHtml(title)}"
              data-product-url="${escapeHtml(url)}"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/>
                <circle cx="12" cy="12" r="3"/>
              </svg>
            </button>` : '';

        if (!wishlistButton && !quickViewButton) return '';

        return `<div class="wcwy-card__actions">${wishlistButton}${quickViewButton}</div>`;
    }

    function renderMobileWishlist(product, options, url, title, image, priceHtml) {
        if (options.showWishlist === false) return '';

        return `
          <button
            class="wcwy-card__wishlist-mobile"
            data-wishlist-btn
            data-product-id="${escapeHtml(product.id || '')}"
            data-product-handle="${escapeHtml(product.handle || '')}"
            data-product-title="${escapeHtml(title)}"
            data-product-image="${escapeHtml(image)}"
            data-product-price="${escapeHtml(priceHtml)}"
            data-product-url="${escapeHtml(url)}"
            aria-label="Add to wishlist"
            aria-pressed="false"
            type="button"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
            </svg>
          </button>`;
    }

    function renderCircleAtc(title, variantId, quickaddOptionIndex, quickaddOptionName, optionCount, handle, url) {
        if (!variantId) return '';

        // Mirrors the Liquid card: when a choice must be made the circle opens a
        // chooser instead of carting the first-listed variant — the option sheet
        // for one option, quick view once there are two or more.
        const needsOptions = quickaddOptionIndex > -1;
        const needsQuickView = needsOptions && optionCount > 1;
        const label = needsQuickView
            ? `Choose options for ${escapeHtml(title)}`
            : (needsOptions
                ? `Choose ${escapeHtml((quickaddOptionName || 'option').toLowerCase())} for ${escapeHtml(title)}`
                : `Add ${escapeHtml(title)} to cart`);

        return `
          <button
            type="button"
            class="wcwy-card__atc"
            aria-label="${label}"
            data-atc-btn
            ${needsOptions ? 'data-needs-options aria-haspopup="dialog"' : ''}
            ${needsQuickView ? `data-needs-quickview data-product-handle="${escapeHtml(handle)}" data-product-url="${escapeHtml(url)}"` : ''}
            data-default-label="${label}"
            data-product-title="${escapeHtml(title)}"
            data-variant-id="${escapeHtml(variantId)}"
            aria-disabled="false"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
              <line x1="3" y1="6" x2="21" y2="6"/>
              <path d="M16 10a4 4 0 0 1-8 0"/>
            </svg>
          </button>`;
    }

    function buildCardJson(product, selectedVariant, variants, onlyDefault, quickaddOptionIndex, quickaddOptionName, optionNames) {
        return JSON.stringify({
            id: product && product.id ? product.id : '',
            handle: product && product.handle ? product.handle : '',
            url: product && product.url ? product.url : ('/products/' + (product && product.handle ? product.handle : '')),
            title: product && product.title ? product.title : '',
            hasOnlyDefaultVariant: onlyDefault,
            optionNames: Array.isArray(optionNames) ? optionNames.slice() : [],
            quickaddOptionIndex: typeof quickaddOptionIndex === 'number' ? quickaddOptionIndex : -1,
            quickaddOptionName: quickaddOptionName || '',
            selectedVariantId: selectedVariant ? selectedVariant.id : '',
            selectedOptions: selectedVariant && Array.isArray(selectedVariant.options) ? selectedVariant.options.slice() : [],
            variants: variants.map(function (variant) {
                return {
                    id: variant.id,
                    available: !!variant.available,
                    options: Array.isArray(variant.options) ? variant.options.slice() : []
                };
            })
        }).replace(/</g, '\\u003c');
    }

    function renderCard(product, settings) {
        if (!product) return '';

        const options = settings || {};
        const context = options.context || 'collection';
        const showPrice = options.showPrice !== false;
        const showQuickView = options.showQuickView === true;
        const optionNames = getOptionNames(product);
        const variants = normalizeVariants(product);
        const selectedVariant = getSelectedVariant(product, variants);
        const onlyDefaultVariant = hasOnlyDefaultVariant(product, optionNames, variants);
        const quickaddOptionIndex = onlyDefaultVariant ? -1 : getQuickaddOptionIndex(optionNames);
        const quickaddValues = quickaddOptionIndex > -1 ? getOptionValues(product, quickaddOptionIndex, variants) : [];
        const title = product.title || '';
        const url = product.url || ('/products/' + (product.handle || ''));
        const primaryImage = getPrimaryImage(product);
        const secondaryImage = options.enableHoverSwap === false ? '' : getSecondaryImage(product);
        const primaryImageSrc = sizedShopifyImageUrl(primaryImage, 640);
        const primaryImageSrcset = buildImageSrcset(primaryImage);
        const secondaryImageSrc = sizedShopifyImageUrl(secondaryImage, 640);
        const secondaryImageSrcset = buildImageSrcset(secondaryImage);
        const cardImageSizes = options.imageSizes || '(min-width: 1400px) 280px, (min-width: 990px) calc((100vw - 104px) / 4), (min-width: 750px) calc((100vw - 72px) / 3), 50vw';
        const hasSecondary = !!secondaryImage;
        const variantId = selectedVariant ? selectedVariant.id : '';
        const priceValue = selectedVariant && typeof selectedVariant.price !== 'undefined' ? selectedVariant.price : product.price;
        const compareValue = selectedVariant && typeof selectedVariant.compare_at_price !== 'undefined'
            ? selectedVariant.compare_at_price
            : product.compare_at_price;
        const priceCents = moneyValueToCents(priceValue);
        const compareCents = moneyValueToCents(compareValue);
        const priceHtml = formatMoneyValue(priceValue);
        const comparePriceHtml = compareCents !== '' && priceCents !== '' && compareCents > priceCents ? formatMoneyValue(compareValue) : '';
        const isOnSale = !!(comparePriceHtml && priceHtml);
        const isSoldOut = variants.length ? !variants.some(function (variant) { return variant.available; }) : product.available === false;
        const selectedOptions = selectedVariant && Array.isArray(selectedVariant.options) ? selectedVariant.options : [];
        const aspectCss = options.aspectCss || '4 / 5';
        const quickaddOptionName = quickaddOptionIndex > -1 ? (optionNames[quickaddOptionIndex] || 'Option') : '';
        const selectedValue = selectedOptions[quickaddOptionIndex] || quickaddValues[0] || '';
        const quickaddSelectHtml = quickaddOptionIndex > -1 && quickaddValues.length ? `
            <label class="wcwy-card__quickadd-field">
              <span class="wcwy-card__sr">${escapeHtml(quickaddOptionName)}</span>
              <select class="wcwy-card__quickadd-select" data-card-option-index="${quickaddOptionIndex}" aria-label="${escapeHtml(quickaddOptionName)}">
                ${quickaddValues.map(function (value) {
                    const isSelected = selectedValue === value;
                    const isAvailable = variants.some(function (variant) {
                        return variant.available && variant.options[quickaddOptionIndex] === value;
                    });
                    return `<option value="${escapeHtml(value)}"${isSelected ? ' selected' : ''}${isAvailable ? '' : ' disabled data-unavailable="true"'}>${escapeHtml(value)}${isAvailable ? '' : ' - Sold out'}</option>`;
                }).join('')}
              </select>
              <span class="wcwy-card__quickadd-icon" aria-hidden="true">
                <svg viewBox="0 0 10 6" focusable="false" aria-hidden="true">
                  <path d="M1 1L5 5L9 1"></path>
                </svg>
              </span>
            </label>` : '';
        const cardJson = buildCardJson(product, selectedVariant, variants, onlyDefaultVariant, quickaddOptionIndex, quickaddOptionName, optionNames);

        return `
          <div class="wcwy-card-wrapper" data-product-id="${escapeHtml(product.id || '')}" data-context="${escapeHtml(context)}" data-card-state="idle" data-anim-card>
            <div class="wcwy-card" data-has-secondary="${hasSecondary ? 'true' : 'false'}" style="--wcwy-card-ratio: ${aspectCss};">
              <div class="wcwy-card__media">
                <a href="${escapeHtml(url)}" class="wcwy-card__media-link" aria-label="View ${escapeHtml(title)}"></a>
                ${primaryImage ? `<img class="wcwy-card__img wcwy-card__img--primary" src="${escapeHtml(primaryImageSrc)}" srcset="${escapeHtml(primaryImageSrcset)}" sizes="${escapeHtml(cardImageSizes)}" alt="${escapeHtml(title)}" loading="lazy" fetchpriority="low" decoding="async">` : '<div class="wcwy-card__placeholder"></div>'}
                ${hasSecondary ? `<img class="wcwy-card__img wcwy-card__img--secondary wcwy-card__img--deferred-hover" data-src="${escapeHtml(secondaryImageSrc)}" data-srcset="${escapeHtml(secondaryImageSrcset)}" data-sizes="${escapeHtml(cardImageSizes)}" alt="${escapeHtml(title)}" loading="lazy" fetchpriority="low" decoding="async" data-hover-secondary-image>` : ''}
                ${isSoldOut ? '<span class="wcwy-card__badge">Sold Out</span>' : ''}
                ${!isSoldOut && isOnSale ? '<span class="wcwy-card__badge wcwy-card__badge--sale">Sale</span>' : ''}
                ${renderActionButtons(product, options, url, title, primaryImage, priceHtml, showQuickView)}
                ${renderMobileWishlist(product, options, url, title, primaryImage, priceHtml)}
                ${!isSoldOut ? renderCircleAtc(title, variantId, quickaddOptionIndex, quickaddOptionName, onlyDefaultVariant ? 0 : optionNames.length, product.handle || '', url) : ''}
              </div>

              <div class="wcwy-card__info">
                <div class="wcwy-card__info-default">
                  <h3 class="wcwy-card__title">
                    <a href="${escapeHtml(url)}" class="wcwy-card__title-link">${escapeHtml(title)}</a>
                  </h3>
                  ${showPrice && priceHtml ? `
                    <div class="wcwy-card__price">
                      ${isOnSale ? `<s>${comparePriceHtml}</s><span class="wcwy-card__sale-price">${priceHtml}</span>` : priceHtml}
                    </div>` : ''}
                </div>

                ${!isSoldOut ? `
                  <div class="wcwy-card__quickadd${quickaddOptionIndex > -1 ? ' wcwy-card__quickadd--with-select' : ' wcwy-card__quickadd--button-only'}" data-card-quickadd>
                    <div class="wcwy-card__quickadd-row${quickaddOptionIndex === -1 ? ' wcwy-card__quickadd-row--button-only' : ''}">
                      ${quickaddSelectHtml}
                      <button type="button" class="wcwy-card__quickadd-btn${quickaddOptionIndex === -1 ? ' wcwy-card__quickadd-btn--full' : ''}" data-card-atc data-default-label="Add to Cart" data-compact-label="Add" data-product-title="${escapeHtml(title)}" data-variant-id="${escapeHtml(variantId)}" aria-disabled="false">Add to Cart</button>
                    </div>
                  </div>` : ''}
                <p class="wcwy-card__status" data-card-status aria-hidden="true"></p>
              </div>
            </div>

            <script type="application/json" class="wcwy-card__product-data" data-card-product-json>${cardJson}</script>
          </div>`;
    }

    function renderSkeleton(options) {
        const settings = options || {};
        const aspectCss = settings.aspectCss || '4 / 5';
        const context = settings.context || 'collection';

        return `
          <div class="wcwy-card-wrapper" data-context="${escapeHtml(context)}" data-anim-card>
            <div class="wcwy-card wcwy-card--skeleton" style="--wcwy-card-ratio: ${aspectCss};">
              <div class="wcwy-card__media">
                <div class="wcwy-card__skeleton-img"></div>
              </div>
              <div class="wcwy-card__info">
                <div class="wcwy-card__skeleton-line"></div>
                <div class="wcwy-card__skeleton-line wcwy-card__skeleton-line--short"></div>
              </div>
            </div>
          </div>`;
    }

    function parseProductData(card) {
        const node = card.querySelector('[data-card-product-json]');
        if (!node) return null;

        try {
            return JSON.parse(node.textContent);
        } catch (error) {
            console.error('WCWN product card JSON parse failed', error);
            return null;
        }
    }

    function canUseHoverImages() {
        return !window.matchMedia || window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    }

    function loadHoverImage(img) {
        if (!img || img.dataset.hoverLoaded === 'true' || !canUseHoverImages()) return;

        const src = img.getAttribute('data-src');
        const srcset = img.getAttribute('data-srcset');
        const sizes = img.getAttribute('data-sizes');

        if (sizes && !img.getAttribute('sizes')) img.setAttribute('sizes', sizes);
        if (srcset && !img.getAttribute('srcset')) img.setAttribute('srcset', srcset);
        if (src && !img.getAttribute('src')) img.setAttribute('src', src);

        img.dataset.hoverLoaded = 'true';
    }

    function markPrimaryImageError(img) {
        if (!img) return;

        const media = img.closest('.wcwy-card__media');
        img.style.display = 'none';
        if (!media || media.querySelector('.wcwy-card__placeholder')) return;

        const placeholder = document.createElement('div');
        placeholder.className = 'wcwy-card__placeholder';
        placeholder.setAttribute('aria-hidden', 'true');
        media.insertBefore(placeholder, media.firstChild);
    }

    function initCardImages(card) {
        if (!card || card.dataset.cardImagesInit === 'true') return;
        card.dataset.cardImagesInit = 'true';

        const primaryImage = card.querySelector('.wcwy-card__img--primary');
        const secondaryImage = card.querySelector('.wcwy-card__img--secondary');
        const cardInner = card.querySelector('.wcwy-card');

        if (primaryImage) {
            if (primaryImage.complete && primaryImage.naturalWidth === 0) {
                markPrimaryImageError(primaryImage);
            } else if (!primaryImage.complete) {
                primaryImage.addEventListener('error', function () {
                    markPrimaryImageError(primaryImage);
                }, { once: true });
            }
        }

        if (!secondaryImage) return;

        function secondaryReady() {
            if (secondaryImage.naturalWidth > 0) {
                secondaryImage.classList.add('is-ready');
            }
        }

        function secondaryFailed() {
            secondaryImage.classList.remove('is-ready');
            secondaryImage.style.display = 'none';
            if (cardInner) cardInner.setAttribute('data-has-secondary', 'false');
        }

        if (secondaryImage.complete) {
            if (secondaryImage.naturalWidth > 0) secondaryReady();
            else if (secondaryImage.getAttribute('src')) secondaryFailed();
        }

        secondaryImage.addEventListener('load', secondaryReady);
        secondaryImage.addEventListener('error', secondaryFailed, { once: true });
    }

    function initHoverImage(card) {
        if (!card || card.dataset.hoverImageInit === 'true') return;

        const hoverImage = card.querySelector('[data-hover-secondary-image]');
        if (!hoverImage) return;

        card.dataset.hoverImageInit = 'true';
        card.addEventListener('pointerenter', function () {
            loadHoverImage(hoverImage);
        }, { once: true, passive: true });
        card.addEventListener('focusin', function () {
            loadHoverImage(hoverImage);
        }, { once: true });
    }

    function getInitialOptions(data) {
        if (data && Array.isArray(data.selectedOptions) && data.selectedOptions.length) {
            return data.selectedOptions.slice();
        }

        const firstAvailable = data && Array.isArray(data.variants)
            ? data.variants.find(function (variant) { return variant.available; }) || data.variants[0]
            : null;

        return firstAvailable && Array.isArray(firstAvailable.options) ? firstAvailable.options.slice() : [];
    }

    var wishlistQueue = [];
    var wishlistQueueTimer = null;

    function getCard(target) {
        return target && target.closest ? target.closest('.wcwy-card-wrapper') : null;
    }

    function getAtcControls(card) {
        return card ? Array.from(card.querySelectorAll('[data-atc-btn], [data-card-atc]')) : [];
    }

    function ensureLiveRegion() {
        var region = document.querySelector('[data-wcwy-card-live]');
        if (region) return region;

        region = document.createElement('div');
        region.className = 'wcwy-card__page-live';
        region.setAttribute('data-wcwy-card-live', '');
        region.setAttribute('role', 'status');
        region.setAttribute('aria-live', 'polite');
        region.setAttribute('aria-atomic', 'true');
        document.body.appendChild(region);
        return region;
    }

    function announce(message) {
        if (!message || !document.body) return;
        var region = ensureLiveRegion();
        region.textContent = '';
        window.setTimeout(function () {
            region.textContent = message;
        }, 20);
    }

    function setCardStatus(card, message) {
        var status = card && card.querySelector('[data-card-status]');
        if (!status) return;
        status.textContent = message || '';
        status.setAttribute('aria-hidden', message ? 'false' : 'true');
    }

    function clearCardStateTimer(card) {
        if (!card || !card._wcwyStateTimer) return;
        window.clearTimeout(card._wcwyStateTimer);
        card._wcwyStateTimer = null;
    }

    function setActionState(card, state, message) {
        if (!card) return;

        var controls = getAtcControls(card);
        var selects = Array.from(card.querySelectorAll('[data-card-option-index]'));
        card.setAttribute('data-card-state', state);
        setCardStatus(card, message);

        controls.forEach(function (control) {
            control.classList.remove('is-loading', 'is-added', 'is-error');
            if (state === 'loading') control.classList.add('is-loading');
            if (state === 'added') control.classList.add('is-added');
            if (state === 'error') control.classList.add('is-error');

            if (state === 'loading' || state === 'added') {
                control.setAttribute('aria-disabled', 'true');
            }

            /* Only the wide quickadd button swaps its label — it is the one
               card control that actually reads "Add to Cart", so "Adding…"
               replaces a word with a word. The circle button is icon-only and
               keeps its spinner; writing text into it would push a label into a
               34px target that has no room for one. */
            if (control.hasAttribute('data-card-atc')) {
                if (state === 'loading') control.textContent = 'Adding…';
                if (state === 'added') control.textContent = 'Added';
                if (state === 'error') control.textContent = 'Try Again';
            } else if (control.hasAttribute('data-atc-btn')) {
                var defaultLabel = control.getAttribute('data-default-label') || 'Add to cart';
                control.setAttribute('aria-label', state === 'loading' ? 'Adding to cart' : (state === 'added' ? 'Added to cart' : defaultLabel));
            }
        });

        selects.forEach(function (select) {
            select.disabled = state === 'loading' || state === 'added';
        });
    }

    function variantMatches(variant, values) {
        var variantOptions = variant && Array.isArray(variant.options) ? variant.options : [];
        return values.every(function (value, index) {
            return typeof value === 'undefined' || variantOptions[index] === value;
        });
    }

    function findVariant(data, values) {
        if (!data || !Array.isArray(data.variants)) return null;
        return data.variants.find(function (variant) {
            return variantMatches(variant, values);
        }) || null;
    }

    function optionHasAvailableVariant(data, values, optionIndex, optionValue) {
        if (!data || !Array.isArray(data.variants)) return false;
        var candidateValues = values.slice();
        candidateValues[optionIndex] = optionValue;
        return data.variants.some(function (variant) {
            return variant.available && variantMatches(variant, candidateValues);
        });
    }

    function markUnavailableOptions(card, values) {
        var data = card._wcwyProductData;
        if (!data) return;

        card.querySelectorAll('[data-card-option-index]').forEach(function (select) {
            var optionIndex = parseInt(select.getAttribute('data-card-option-index'), 10);
            if (Number.isNaN(optionIndex)) return;

            Array.from(select.options).forEach(function (option) {
                var baseLabel = option.getAttribute('data-card-option-label')
                    || option.textContent.replace(/\s+-\s+Sold out$/, '');
                var available = optionHasAvailableVariant(data, values, optionIndex, option.value);
                var isSelected = option.value === select.value;

                option.setAttribute('data-card-option-label', baseLabel);
                option.textContent = baseLabel + (available ? '' : ' - Sold out');
                option.disabled = !available && !isSelected;
                option.setAttribute('data-unavailable', available ? 'false' : 'true');
            });
        });
    }

    function updateAtcControls(card, variant, available) {
        var variantId = variant ? variant.id : '';

        getAtcControls(card).forEach(function (control) {
            var title = control.getAttribute('data-product-title') || '';
            var defaultLabel = control.getAttribute('data-default-label') || 'Add to Cart';

            control.setAttribute('data-variant-id', variantId);

            // A needs-options button opens the sheet rather than adding, so one
            // sold-out variant must not lock the shopper out of the others.
            if (control.hasAttribute('data-needs-options')) {
                control.disabled = false;
                control.setAttribute('aria-disabled', 'false');
                control.classList.remove('is-soldout', 'is-loading', 'is-added', 'is-error');
                control.setAttribute('aria-label', defaultLabel);
                return;
            }

            control.disabled = !available;
            control.setAttribute('aria-disabled', available ? 'false' : 'true');
            control.classList.toggle('is-soldout', !available);
            control.classList.remove('is-loading', 'is-added', 'is-error');

            if (control.hasAttribute('data-card-atc')) {
                control.textContent = available ? defaultLabel : (variant ? 'Sold Out' : 'Unavailable');
            } else {
                control.setAttribute('aria-label', available
                    ? defaultLabel
                    : (variant ? ((title ? title + ' is' : 'Variant is') + ' sold out') : 'Variant unavailable'));
            }
        });
    }

    function getUnavailableMessages(card, changedIndex, variant) {
        var select = typeof changedIndex === 'number' && changedIndex > -1
            ? card.querySelector('[data-card-option-index="' + changedIndex + '"]')
            : null;
        var optionName = select ? (select.getAttribute('aria-label') || 'option') : 'option';
        var value = select ? select.value : '';

        if (variant && value) {
            return {
                visible: optionName + ' ' + value + ' is sold out.',
                announcement: 'Sold out in ' + optionName.toLowerCase() + ' ' + value
            };
        }

        return {
            visible: 'This option combination is unavailable.',
            announcement: 'This option combination is unavailable'
        };
    }

    function syncCard(card, changedIndex, shouldAnnounce) {
        var data = card && card._wcwyProductData;
        if (!data || !getAtcControls(card).length) return;

        var selects = Array.from(card.querySelectorAll('[data-card-option-index]'));
        var variants = Array.isArray(data.variants) ? data.variants : [];
        var currentOptions = Array.isArray(card._wcwySelectedOptions)
            ? card._wcwySelectedOptions.slice()
            : getInitialOptions(data);

        selects.forEach(function (select) {
            var optionIndex = parseInt(select.getAttribute('data-card-option-index'), 10);
            if (Number.isNaN(optionIndex)) return;
            currentOptions[optionIndex] = select.value;
        });

        card._wcwySelectedOptions = currentOptions;
        markUnavailableOptions(card, currentOptions);

        var variant;
        if (!selects.length) {
            var selectedId = data.selectedVariantId;
            variant = variants.find(function (item) {
                return selectedId && String(item.id) === String(selectedId);
            }) || variants[0] || null;
        } else {
            variant = findVariant(data, currentOptions);
        }

        if (variant && variant.available) {
            data.selectedVariantId = variant.id;
            updateAtcControls(card, variant, true);
            if (card.getAttribute('data-card-state') === 'soldout') {
                card.setAttribute('data-card-state', 'idle');
                setCardStatus(card, '');
            }
            return;
        }

        updateAtcControls(card, variant, false);
        var reason = getUnavailableMessages(card, changedIndex, variant);
        card.setAttribute('data-card-state', 'soldout');
        setCardStatus(card, reason.visible);
        if (shouldAnnounce) announce(reason.announcement);
    }

    function getCartErrorMessage(error) {
        var message = error && (error.description || error.message);
        if (!message && error && error.errors) message = error.errors;
        if (typeof message !== 'string' || !message.trim() || /failed to fetch|networkerror/i.test(message)) {
            return "Couldn't add - try again";
        }
        return message.trim().slice(0, 180);
    }

    function addVariantToCart(variantId) {
        if (window.CartDrawer && typeof window.CartDrawer.addItems === 'function') {
            return window.CartDrawer.addItems(
                [{ id: Number(variantId), quantity: 1 }],
                { open: false }
            ).then(function (data) {
                return { data: data, drawerReady: true };
            });
        }

        return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: Number(variantId),
                quantity: 1
            })
        }).then(function (response) {
            return response.json().catch(function () {
                return {};
            }).then(function (data) {
                if (!response.ok) throw data;
                return { data: data, drawerReady: false };
            });
        });
    }

    function openCartDrawerAfterConfirmation(drawerReady) {
        if (!window.CartDrawer || typeof window.CartDrawer.open !== 'function') return;

        window.setTimeout(function () {
            if (drawerReady || typeof window.CartDrawer.fetchCart !== 'function') {
                window.CartDrawer.open(false);
                return;
            }

            Promise.resolve(window.CartDrawer.fetchCart()).then(function () {
                window.CartDrawer.open(false);
            });
        }, 220);
    }

    function startAddToCart(card, control) {
        if (!card || !control || card._wcwyRequestInFlight) return;
        if (control.disabled || control.getAttribute('aria-disabled') === 'true') return;
        if (card.getAttribute('data-card-state') === 'added') return;

        var variantId = control.getAttribute('data-variant-id');
        if (!variantId) {
            setActionState(card, 'error', 'Choose an available option.');
            announce('Choose an available option');
            return;
        }

        clearCardStateTimer(card);
        card._wcwyRequestInFlight = true;
        card._wcwyRequestToken = (card._wcwyRequestToken || 0) + 1;
        var requestToken = card._wcwyRequestToken;

        setActionState(card, 'loading', 'Adding to cart...');
        announce('Adding to cart');

        addVariantToCart(variantId).then(function (result) {
            if (!card.isConnected || requestToken !== card._wcwyRequestToken) return;

            card._wcwyRequestInFlight = false;
            setActionState(card, 'added', 'Added to cart');
            announce('Added to cart');
            openCartDrawerAfterConfirmation(result.drawerReady);

            card._wcwyStateTimer = window.setTimeout(function () {
                if (requestToken !== card._wcwyRequestToken) return;
                setActionState(card, 'idle', '');
                syncCard(card, -1, false);
            }, 1350);
        }).catch(function (error) {
            if (!card.isConnected || requestToken !== card._wcwyRequestToken) return;

            card._wcwyRequestInFlight = false;
            var message = getCartErrorMessage(error);
            syncCard(card, -1, false);
            setActionState(card, 'error', message);
            getAtcControls(card).forEach(function (button) {
                button.disabled = false;
                button.setAttribute('aria-disabled', 'false');
            });
            announce(message);

            card._wcwyStateTimer = window.setTimeout(function () {
                if (requestToken !== card._wcwyRequestToken) return;
                setActionState(card, 'idle', '');
                syncCard(card, -1, false);
            }, 5000);
        });
    }

    function productFromWishlistButton(button) {
        return {
            id: button.getAttribute('data-product-id'),
            handle: button.getAttribute('data-product-handle'),
            title: button.getAttribute('data-product-title'),
            image: button.getAttribute('data-product-image'),
            price: button.getAttribute('data-product-price'),
            url: button.getAttribute('data-product-url')
        };
    }

    function setWishlistState(productId, active) {
        document.querySelectorAll('[data-wishlist-btn]').forEach(function (button) {
            if (String(button.getAttribute('data-product-id')) !== String(productId)) return;
            button.classList.toggle('is-active', active);
            button.classList.toggle('is-wishlisted', active);
            button.setAttribute('aria-pressed', active ? 'true' : 'false');
            button.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
        });
    }

    function hydrateWishlist(root) {
        if (!window.WCWYWishlist || typeof window.WCWYWishlist.hasItem !== 'function') return;

        if (typeof window.WCWYWishlist.updateUI === 'function') {
            window.WCWYWishlist.updateUI();
        }

        (root || document).querySelectorAll('[data-wishlist-btn]').forEach(function (button) {
            var productId = button.getAttribute('data-product-id');
            if (!productId) return;
            setWishlistState(productId, window.WCWYWishlist.hasItem(productId));
            button.removeAttribute('data-wishlist-pending');
        });
    }

    function performWishlistToggle(task) {
        if (!task || !window.WCWYWishlist || typeof window.WCWYWishlist.toggleItem !== 'function') return;

        try {
            window.WCWYWishlist.toggleItem(task.product);
            if (typeof window.WCWYWishlist.updateUI === 'function') {
                window.WCWYWishlist.updateUI();
            }
            hydrateWishlist(document);
        } catch (error) {
            var active = typeof window.WCWYWishlist.hasItem === 'function'
                ? window.WCWYWishlist.hasItem(task.product.id)
                : false;
            setWishlistState(task.product.id, active);
            announce('Wishlist unavailable - try again');
        }
    }

    function takeQueuedWishlistTask(button) {
        var index = wishlistQueue.findIndex(function (task) {
            return task.button === button;
        });
        if (index === -1) return null;
        return wishlistQueue.splice(index, 1)[0];
    }

    function flushWishlistQueue() {
        if (!window.WCWYWishlist || typeof window.WCWYWishlist.toggleItem !== 'function') return;

        var queued = wishlistQueue.slice();
        wishlistQueue = [];
        queued.forEach(performWishlistToggle);

        if (wishlistQueueTimer) {
            window.clearInterval(wishlistQueueTimer);
            wishlistQueueTimer = null;
        }
    }

    function scheduleWishlistQueue() {
        if (wishlistQueueTimer) return;
        wishlistQueueTimer = window.setInterval(flushWishlistQueue, 100);
    }

    function handleWishlistClick(event, button) {
        event.preventDefault();
        event.stopImmediatePropagation();

        var queuedTask = !event.isTrusted ? takeQueuedWishlistTask(button) : null;
        if (window.WCWYWishlist && typeof window.WCWYWishlist.toggleItem === 'function') {
            performWishlistToggle(queuedTask || {
                button: button,
                product: productFromWishlistButton(button)
            });
            flushWishlistQueue();
            return;
        }

        var product = productFromWishlistButton(button);
        var active = button.getAttribute('aria-pressed') === 'true';
        setWishlistState(product.id, !active);
        button.setAttribute('data-wishlist-pending', 'true');
        wishlistQueue.push({ button: button, product: product });
        scheduleWishlistQueue();
    }

    /* -------------------------------------------------------------------------
       QUICK VIEW — the modal is a single shared instance owned by
       assets/wcwy-quick-view.js and loaded on demand by the bootstrap in
       layout/theme.liquid. Nothing is rendered per card, so all this has to do
       is hand the trigger over (and fall back to the product page if the module
       genuinely cannot be reached).
       ------------------------------------------------------------------------- */
    function requestQuickView(trigger) {
        if (window.WCWYQuickView && typeof window.WCWYQuickView.open === 'function') {
            window.WCWYQuickView.open(trigger);
            return true;
        }

        if (typeof window.WCWYQuickViewLoad !== 'function') return false;

        setQuickViewPending(trigger, true);
        window.WCWYQuickViewLoad().then(function (api) {
            setQuickViewPending(trigger, false);
            if (api && typeof api.open === 'function') {
                api.open(trigger);
                return;
            }
            navigateToProduct(trigger);
        }).catch(function () {
            setQuickViewPending(trigger, false);
            navigateToProduct(trigger);
        });

        return true;
    }

    function setQuickViewPending(trigger, pending) {
        trigger.classList.toggle('is-pending', pending);
        trigger.setAttribute('aria-busy', pending ? 'true' : 'false');

        if (pending) {
            trigger.setAttribute('data-default-aria-label', trigger.getAttribute('aria-label') || 'Quick view');
            trigger.setAttribute('aria-label', 'Opening quick view');
            return;
        }

        trigger.setAttribute('aria-label', trigger.getAttribute('data-default-aria-label') || 'Quick view');
    }

    function navigateToProduct(trigger) {
        var url = trigger.getAttribute('data-product-url');
        if (!url) {
            var card = getCard(trigger);
            var link = card && card.querySelector('.wcwy-card__title-link, .wcwy-card__media-link');
            url = link ? link.getAttribute('href') : '';
        }
        if (url) window.location.href = url;
    }

    function handleQuickViewClick(event, button) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (button.getAttribute('aria-busy') === 'true') return;

        if (!requestQuickView(button)) navigateToProduct(button);
    }

    /* -------------------------------------------------------------------------
       OPTION SHEET — touch replacement for the desktop hover quickadd select.
       The circle add-to-cart is the only ATC available on touch, and adding
       straight from it would silently cart the first-listed variant. When the
       product needs an option choice the button opens this sheet instead; the
       values come from the card's inlined product JSON, so there is no fetch.
       ------------------------------------------------------------------------- */
    var optionSheet = null;
    var optionSheetContext = null;

    function buildOptionSheet() {
        var sheet = document.createElement('div');
        sheet.className = 'wcwy-option-sheet';
        sheet.setAttribute('data-wcwy-option-sheet', '');
        sheet.hidden = true;
        /* Mirrors the quick-view modal's anatomy — image, eyebrow, title, price,
           then a labelled option row — because the two are the same job and
           looked like different products of different quality side by side. The
           image is not fetched: it is the card's own <img>, already decoded and
           on screen, so this stays a zero-network sheet. */
        sheet.innerHTML = [
            '<div class="wcwy-option-sheet__scrim" data-option-sheet-dismiss></div>',
            '<div class="wcwy-option-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="wcwy-option-sheet-title">',
            '<button type="button" class="wcwy-option-sheet__close" data-option-sheet-dismiss aria-label="Close">',
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
            '</button>',
            '<div class="wcwy-option-sheet__head">',
            '<div class="wcwy-option-sheet__media" data-option-sheet-media hidden>',
            '<img alt="" data-option-sheet-image decoding="async">',
            '</div>',
            '<div class="wcwy-option-sheet__meta">',
            '<p class="wcwy-option-sheet__eyebrow" data-option-sheet-eyebrow></p>',
            '<p class="wcwy-option-sheet__title" id="wcwy-option-sheet-title"></p>',
            '<p class="wcwy-option-sheet__price" data-option-sheet-price hidden></p>',
            '</div>',
            '</div>',
            '<div class="wcwy-option-sheet__row">',
            '<span class="wcwy-option-sheet__row-label" data-option-sheet-label></span>',
            '<span class="wcwy-option-sheet__row-value" data-option-sheet-selected></span>',
            '</div>',
            '<div class="wcwy-option-sheet__values" data-option-sheet-values></div>',
            '<a class="wcwy-option-sheet__link" data-option-sheet-link>View full details</a>',
            '</div>'
        ].join('');

        document.body.appendChild(sheet);
        return sheet;
    }

    function ensureOptionSheet() {
        if (!optionSheet || !optionSheet.isConnected) optionSheet = buildOptionSheet();
        return optionSheet;
    }

    function closeOptionSheet(restoreFocus) {
        if (!optionSheet || optionSheet.hidden) return;

        var trigger = optionSheetContext && optionSheetContext.control;
        optionSheet.classList.remove('is-open');
        optionSheet.hidden = true;
        optionSheetContext = null;
        document.documentElement.classList.remove('wcwy-option-sheet-open');

        if (restoreFocus && trigger && trigger.isConnected) trigger.focus();
    }

    function openOptionSheet(card, control) {
        var data = card && card._wcwyProductData;
        if (!data) return false;

        var optionIndex = typeof data.quickaddOptionIndex === 'number'
            ? data.quickaddOptionIndex
            : -1;
        if (optionIndex < 0) return false;

        var values = Array.isArray(card._wcwySelectedOptions)
            ? card._wcwySelectedOptions.slice()
            : getInitialOptions(data);

        // Distinct values for the chosen option, in variant order.
        var seen = Object.create(null);
        var optionValues = [];
        (Array.isArray(data.variants) ? data.variants : []).forEach(function (variant) {
            var value = Array.isArray(variant.options) ? variant.options[optionIndex] : undefined;
            if (typeof value !== 'string' || seen[value]) return;
            seen[value] = true;
            optionValues.push(value);
        });
        if (!optionValues.length) return false;

        var sheet = ensureOptionSheet();
        var optionName = data.quickaddOptionName || 'Option';
        var title = data.title || (control && control.getAttribute('data-product-title')) || '';

        sheet.querySelector('[data-option-sheet-eyebrow]').textContent = 'Quick add';
        sheet.querySelector('#wcwy-option-sheet-title').textContent = title;
        sheet.querySelector('[data-option-sheet-label]').textContent = optionName;

        var link = sheet.querySelector('[data-option-sheet-link]');
        link.setAttribute('href', data.url || '#');

        /* Image and price are read off the rendered card, not the inlined JSON —
           the card JSON carries ids, options and availability only. The card's
           <img> is already loaded, so reusing its src costs nothing, and its
           price node is already formatted in the shop's currency, which saves
           re-deriving money formatting from a variant. */
        var media = sheet.querySelector('[data-option-sheet-media]');
        var image = sheet.querySelector('[data-option-sheet-image]');
        var cardImg = card.querySelector('.wcwy-card__img--primary, .wcwy-card__img, img');
        var cardImgSrc = cardImg && (cardImg.currentSrc || cardImg.getAttribute('src'));

        if (cardImgSrc) {
            image.setAttribute('src', cardImgSrc);
            image.setAttribute('alt', title);
            media.hidden = false;
        } else {
            image.removeAttribute('src');
            media.hidden = true;
        }

        var priceNode = sheet.querySelector('[data-option-sheet-price]');
        var cardPrice = card.querySelector('.wcwy-card__price, [data-card-price]');
        var cardPriceText = cardPrice ? cardPrice.textContent.trim() : '';

        if (cardPriceText) {
            priceNode.textContent = cardPriceText;
            priceNode.hidden = false;
        } else {
            priceNode.textContent = '';
            priceNode.hidden = true;
        }

        /* Blank, not the default variant's value — see the tile loop below.
           Nothing is selected until the shopper taps, and this line is the
           readout for that state. */
        var selectedNode = sheet.querySelector('[data-option-sheet-selected]');
        selectedNode.textContent = '';

        // Built as nodes, not markup: the shared escapeHtml() goes through
        // innerHTML and so leaves double quotes intact, which an option value
        // like '36" waist' would use to break out of an attribute.
        var container = sheet.querySelector('[data-option-sheet-values]');
        container.textContent = '';
        optionValues.forEach(function (value, index) {
            var available = optionHasAvailableVariant(data, values, optionIndex, value);
            var button = document.createElement('button');

            /* Nothing is preselected. This sheet is tap-to-add — any tile adds
               that variant immediately — so marking one "active" on open showed
               a choice the shopper had not made and implied the add had already
               been aimed somewhere. The mark was inherited from the card's
               default variant, which is just the first one Shopify listed, not
               an intention. Every tile opens equal; the tap is the decision. */
            button.type = 'button';
            button.className = 'wcwy-option-sheet__value';
            button.setAttribute('data-option-sheet-index', String(index));
            button.setAttribute('aria-pressed', 'false');
            button.setAttribute('aria-label', optionName + ' ' + value + (available ? '' : ', sold out'));
            button.appendChild(document.createTextNode(value));

            if (!available) {
                button.disabled = true;
                button.setAttribute('aria-disabled', 'true');
                var note = document.createElement('span');
                note.className = 'wcwy-option-sheet__soldout';
                note.textContent = 'Sold out';
                button.appendChild(note);
            }

            container.appendChild(button);
        });

        optionSheetContext = {
            card: card,
            control: control,
            optionIndex: optionIndex,
            values: values,
            optionValues: optionValues
        };

        sheet.hidden = false;
        document.documentElement.classList.add('wcwy-option-sheet-open');
        // Next frame so the open transition runs from the hidden state.
        window.requestAnimationFrame(function () {
            sheet.classList.add('is-open');
        });

        /* Focus the close button, not the first value tile. Nothing is
           preselected here, but focusing a tile paints a ring on it that reads
           as a choice already made — and on iOS that ring sticks until the
           shopper taps elsewhere, so the sheet opened looking pre-answered.
           Close sits before the tiles in DOM order, so Tab still walks straight
           into the options for keyboard users. */
        var closeBtn = sheet.querySelector('.wcwy-option-sheet__close');
        (closeBtn || container.querySelector('[data-option-sheet-index]:not([disabled])')).focus();

        return true;
    }

    function handleOptionSheetSelection(valueButton) {
        if (!optionSheetContext) return;

        var card = optionSheetContext.card;
        var control = optionSheetContext.control;
        var optionIndex = optionSheetContext.optionIndex;
        var data = card && card._wcwyProductData;
        if (!data || !card.isConnected) {
            closeOptionSheet(false);
            return;
        }

        var valueIndex = parseInt(valueButton.getAttribute('data-option-sheet-index'), 10);
        if (Number.isNaN(valueIndex)) return;

        var values = optionSheetContext.values.slice();
        values[optionIndex] = optionSheetContext.optionValues[valueIndex];

        var variant = findVariant(data, values);
        if (!variant || !variant.available) {
            announce('That option is sold out');
            return;
        }

        // Persist the choice so the post-add syncCard resolves to it rather than
        // falling back to the first-listed variant.
        card._wcwySelectedOptions = values;
        data.selectedVariantId = variant.id;
        control.setAttribute('data-variant-id', variant.id);

        closeOptionSheet(true);
        startAddToCart(card, control);
    }

    function handleOptionSheetClick(event) {
        if (!optionSheetContext) return;

        var target = event.target;
        if (!target || !target.closest) return;

        if (target.closest('[data-option-sheet-dismiss]')) {
            event.preventDefault();
            closeOptionSheet(true);
            return;
        }

        var valueButton = target.closest('[data-option-sheet-index]');
        if (valueButton && !valueButton.disabled) {
            event.preventDefault();
            handleOptionSheetSelection(valueButton);
        }
    }

    function handleDocumentClick(event) {
        var target = event.target;
        if (!target || !target.closest) return;

        if (optionSheetContext && target.closest('[data-wcwy-option-sheet]')) {
            event.stopImmediatePropagation();
            handleOptionSheetClick(event);
            return;
        }

        var wishlistButton = target.closest('[data-wishlist-btn]');
        if (wishlistButton) {
            handleWishlistClick(event, wishlistButton);
            return;
        }

        var quickViewButton = target.closest('[data-quickview-btn]');
        if (quickViewButton) {
            handleQuickViewClick(event, quickViewButton);
            return;
        }

        var atcControl = target.closest('[data-atc-btn], [data-card-atc]');
        if (!atcControl) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        var atcCard = getCard(atcControl);

        // Two or more options: the one-option sheet cannot serve this product,
        // so the circle opens quick view instead.
        if (atcControl.hasAttribute('data-needs-quickview')) {
            if (requestQuickView(atcControl)) return;
        }

        if (atcControl.hasAttribute('data-needs-options')) {
            // Fall through to a plain add only if the sheet cannot be built —
            // better to add something than to leave a dead button.
            if (openOptionSheet(atcCard, atcControl)) return;
        }

        startAddToCart(atcCard, atcControl);
    }

    function handleDocumentChange(event) {
        var select = event.target;
        if (!select || !select.matches || !select.matches('[data-card-option-index]')) return;

        var card = getCard(select);
        if (!card || card._wcwyRequestInFlight) return;

        var optionIndex = parseInt(select.getAttribute('data-card-option-index'), 10);
        if (Number.isNaN(optionIndex)) return;

        clearCardStateTimer(card);
        card.setAttribute('data-card-state', 'idle');
        if (!Array.isArray(card._wcwySelectedOptions)) {
            card._wcwySelectedOptions = getInitialOptions(card._wcwyProductData);
        }
        card._wcwySelectedOptions[optionIndex] = select.value;
        syncCard(card, optionIndex, true);
    }

    function initCard(card) {
        if (!card) return;
        initCardImages(card);
        initHoverImage(card);
        if (card.dataset.cardQuickaddInit === 'true') return;

        var data = parseProductData(card);
        if (!data) return;

        card._wcwyProductData = data;
        card._wcwySelectedOptions = getInitialOptions(data);
        card.dataset.cardQuickaddInit = 'true';
        if (!card.getAttribute('data-card-state')) card.setAttribute('data-card-state', 'idle');
        syncCard(card, -1, false);
    }

    function init(root) {
        var scope = root || document;
        var cards = Array.from(scope.querySelectorAll('.wcwy-card-wrapper'));
        if (scope.matches && scope.matches('.wcwy-card-wrapper')) cards.unshift(scope);

        cards.forEach(initCard);
        ensureLiveRegion();
        hydrateWishlist(scope);
    }

    document.addEventListener('click', handleDocumentClick, true);
    document.addEventListener('change', handleDocumentChange);
    document.addEventListener('keydown', function (event) {
        if (!optionSheetContext || !optionSheet) return;

        if (event.key === 'Escape') {
            closeOptionSheet(true);
            return;
        }

        if (event.key !== 'Tab') return;

        // Keep focus inside the dialog: aria-modal is advisory for AT only.
        var focusable = Array.from(optionSheet.querySelectorAll(
            '[data-option-sheet-index]:not([disabled]), .wcwy-option-sheet__close, .wcwy-option-sheet__link'
        ));
        if (!focusable.length) return;

        var first = focusable[0];
        var last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        } else if (!optionSheet.contains(document.activeElement)) {
            event.preventDefault();
            first.focus();
        }
    });

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            init(document);
        });
    } else {
        init(document);
    }

    document.addEventListener('wcwy:product-card:refresh', function (event) {
        init((event.detail && event.detail.root) || document);
    });

    window.addEventListener('wcwy:wishlist', function (event) {
        hydrateWishlist(document);
        var action = event.detail && event.detail.action;
        if (action === 'add') announce('Added to wishlist');
        if (action === 'remove') announce('Removed from wishlist');
    });

    window.WCWYProductCard = {
        refresh: init,
        render: renderCard,
        renderSkeleton: renderSkeleton
    };
})();
